// @flow
import type { CurrentUser as ApiCurrentUser } from 'api/currentUser';
import { EMPTY_SEARCH_LOCATION } from 'utils/constants';
import { removeId } from 'utils/functional';
import type { Action } from '../actions/currentUser';

export type CurrentUser = {
  ...ApiCurrentUser,
  isFetching?: boolean,
  isLoaded: boolean,
  applicantProfileIsLoaded: boolean,
  applicantProfileIsFetching?: boolean
};

export type State = CurrentUser;

export default function currentUser(
  state: State = { isLoaded: false, applicantProfileIsLoaded: false },
  action: Action
) {
  switch (action.type) {
    case 'CURRENT_USER_FETCH_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'CURRENT_USER_FETCH_SUCCESS':
      return {
        ...action.currentUser,
        isFetching: false,
        isLoaded: true
      };
    case 'CURRENT_USER_UPDATE_PARTIAL':
      return {
        ...state,
        ...action.currentUserPartial
      };
    case 'CURRENT_USER_UPDATE_SEARCH_LOCATION':
      return {
        ...state,
        searchLocation: action.location
      };
    case 'CURRENT_USER_CLEAR_SEARCH_LOCATION':
      return {
        ...state,
        searchLocation: EMPTY_SEARCH_LOCATION
      };
    case 'SAVE_LISTING': {
      const { listingId, listingType } = action;
      if (
        state.savedListings &&
        state.savedListings.find(listing => listing.id === listingId)
      ) {
        return state;
      }
      return {
        ...state,
        savedListings: [
          ...(state.savedListings || []),
          { id: listingId, type: listingType }
        ]
      };
    }
    case 'UNSAVE_LISTING': {
      const { listingId } = action;
      return {
        ...state,
        savedListings: removeId(state.savedListings || [], listingId)
      };
    }
    case 'SAVE_SEARCH': {
      const { savedSearch } = action;
      if (
        state.savedSearches &&
        state.savedSearches.find(search => search.id === savedSearch.id)
      ) {
        return state;
      }
      return {
        ...state,
        savedSearches: [...(state.savedSearches || []), savedSearch]
      };
    }
    case 'UNSAVE_SEARCH': {
      const { searchId } = action;
      return {
        ...state,
        savedSearches: removeId(state.savedSearches || [], searchId)
      };
    }
    case 'APPLICANT_PROFILE_FETCH_REQUEST':
      return {
        ...state,
        applicantProfileIsFetching: true
      };
    case 'APPLICANT_PROFILE_FETCH_SUCCESS':
      return {
        ...state,
        ...action.currentUserPartial,
        applicantProfileIsFetching: false,
        applicantProfileIsLoaded: true
      };
    case 'APPLICANT_PROFILE_FETCH_FAILURE':
      return {
        ...state,
        applicantProfileIsFetching: false
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
